<template>
    <v-row>
        <v-col align-self="center" align="center">
            <v-row style="max-width: 25%;">
                <v-col>
                    <img src="../../assets/images/archibald_lightgrey_big.png" alt="" width="100%">
                    <div class="hover-title">
                        <h2 style="color: #eb5c2e;">
                            Archibald
                        </h2>
                        <p>
                            Simulateur TLPE
                        </p>
                    </div>
                    <!--                    <v-radio-group v-model="generic" row>-->
                    <!--                        <v-radio-->
                    <!--                            :label="`Version générique`"-->
                    <!--                            :value="true"-->
                    <!--                            color="#eb5c2e"-->
                    <!--                        />-->
                    <!--                        <v-radio-->
                    <!--                            :label="`Choisir une collectivité`"-->
                    <!--                            :value="false"-->
                    <!--                            color="#eb5c2e"-->
                    <!--                        />-->
                    <!--                    </v-radio-group>-->
                    <multiselect
                        v-if="!generic"
                        v-model="collectiviteSelected"
                        :options="collectivites"
                        :close-on-select="true"
                        :show-labels="false"
                        :hide-selected="true"
                        :custom-label="t => `${t.commune.nom}`"
                        :loading="collectivitesLoading"
                        placeholder="Choisissez une collectivité"
                    >
                        <template
                            slot="option"
                            slot-scope="props"
                        >
                            {{ props.option.commune.nom }}
                        </template>
                    </multiselect>
                    <v-btn
                        :disabled="!isFormComplete()"
                        style="margin-top: 1em;"
                        color="#eb5c2e"
                        large
                        dark
                        block
                        @click="enter()"
                    >
                        Entrer
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { toLower } from '../../utils'

export default {
    name: 'Welcome',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {
            collectiviteSelected: null,
            generic: false,
            collectivitesLoading: true,
        };
    },
    computed: {
        ...mapState('collectivite', ['collectivites']),
    },
    watch: {},
    created() {
        this.getCollectivites()
            .then(() => {
                this.collectivitesLoading = false;
            });
    },
    methods: {
        ...mapActions('support', ['addSupport']),
        ...mapActions('collectivite', ['getCollectivites']),
        isFormComplete() {
            return this.collectiviteSelected || this.generic;
        },
        enter() {
            if (this.isFormComplete()) {
                if (this.generic) {
                    this.$router.push({ name: 'simulateur-generique' });
                } else {
                    this.$router.push({ name: 'simulateur-collectivite', params: { collectivite: toLower(this.collectiviteSelected.site_internet) } });
                }
            }
        },
    },
}
</script>

<style scoped>
.hover-title {
    position: absolute;
    top: 50%;
    transform: translate(0%, -150%);
    left: 0;
    width: 100%;
    font-size: 2em;
    font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome/Welcome.vue